import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import axiosRetry from 'axios-retry';
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.use(VueSweetalert2);

axios.defaults.baseURL = process.env.VUE_APP_URL_API;
// Aplicar axios-retry a la instancia global de Axios
axiosRetry(axios, {
  retries: 3, // Número de reintentos
  retryDelay: axiosRetry.exponentialDelay, // Retraso exponencial: 1s, 2s, 4s...
  retryCondition: (error) => {
    // Reintenta si hay error de conexión/red O si el servidor responde con 5xx (ej. error 500 al iniciar .NET)
    return axiosRetry.isNetworkOrIdempotentRequestError(error) || 
           (error.response && error.response.status >= 500);
  },
  onRetry: (retryCount, error, requestConfig) => {
    console.warn(`[AxiosRetry] Reintento #${retryCount} para ${requestConfig.url} debido a:`, error.message);
  }
});
Vue.prototype.$http = axios;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
